import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';
import type { CampoApi } from '@/services/Relatorios';

interface SortableItemProps {
  campo: CampoApi;
  index: number;
  isVisivel: boolean;
  isSelected: boolean;
  onToggleSelection: (id: number) => void;
}

export function SortableItem({
  campo,
  index,
  isVisivel,
  isSelected,
  onToggleSelection,
}: SortableItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: campo.Campo_id,
    data: { campo, isVisivel },
  });

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={cn(
        'flex items-center gap-3 rounded-lg border bg-card p-3 transition-all duration-200 hover:bg-accent/50',
        isDragging && 'opacity-50 ring-2 ring-primary shadow-lg'
      )}
    >
      <div {...attributes} {...listeners} className="touch-none cursor-grab active:cursor-grabbing">
        <GripVertical className="h-5 w-5 text-muted-foreground transition-colors hover:text-foreground" />
      </div>
      <span className="w-8 shrink-0 text-sm font-medium text-muted-foreground">{index + 1}</span>
      {isVisivel && (
        <Checkbox
          checked={isSelected}
          onCheckedChange={() => onToggleSelection(campo.Campo_id)}
          className="shrink-0"
        />
      )}
      <span
        className="flex-1 wrap-break-word text-sm leading-snug whitespace-normal"
        title={campo.Descricao_Campo}
      >
        {campo.Descricao_Campo}
      </span>
    </div>
  );
}
